import { render } from "./LayoutNotify.vue?vue&type=template&id=eccab910&scoped=true"
import script from "./LayoutNotify.vue?vue&type=script&lang=js"
export * from "./LayoutNotify.vue?vue&type=script&lang=js"

import "./LayoutNotify.vue?vue&type=style&index=0&id=eccab910&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eccab910"]])

export default __exports__